/* Lukeva LP — skrypt landera: wideo (pauza poza ekranem), slider opinii (strzałki, kropki, swipe), opcjonalny przyklejony pasek CTA.
   Idempotentny; działa też w edytorze motywu (shopify:section:load). Bez zależności. */
(function () {
  'use strict';
  if (window.__lklpLoaded) return;
  window.__lklpLoaded = true;

  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function safePlay(v) { try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }

  /* ---------- wideo (GIF-y donora jako MP4) ---------- */
  function initVideos(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    qsa('video[data-lklp-video]', root).forEach(function (v) {
      if (v.__lklp) return;
      v.__lklp = true;
      v.muted = true;
      if (reduce) { v.removeAttribute('autoplay'); try { v.pause(); } catch (e) {} return; }
      if (!('IntersectionObserver' in window)) { safePlay(v); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { safePlay(v); } else { try { v.pause(); } catch (e) {} }
        });
      }, { rootMargin: '120px' });
      io.observe(v);
    });
  }

  /* ---------- slider opinii ---------- */
  function initSlider(el) {
    if (el.__lklp) return;
    el.__lklp = true;
    var track = el.querySelector('[data-lklp-track]');
    if (!track) return;
    var cards = qsa('[data-lklp-card]', track);
    var dots = qsa('[data-lklp-dot]', el);
    var prev = el.querySelector('[data-lklp-prev]');
    var next = el.querySelector('[data-lklp-next]');
    if (!cards.length) return;
    var manualUntil = 0;
    var raf = 0;

    function pad() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function target(i) {
      var c = cards[i];
      return c.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - pad();
    }
    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function current() {
      if (track.scrollLeft >= maxScroll() - 2 && maxScroll() > 2) return cards.length - 1;
      var x = track.scrollLeft, best = 0, bd = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(target(i) - x);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }
    function mark(i) {
      dots.forEach(function (d, k) {
        var on = k === i;
        d.classList.toggle('is-active', on);
        if (on) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
      });
    }
    function go(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      manualUntil = Date.now() + 700;
      mark(i);
      track.scrollTo({ left: Math.min(target(i), maxScroll()), behavior: 'smooth' });
    }
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (Date.now() < manualUntil) return;
        mark(current());
      });
    }
    function step(dir) {
      var i = current();
      if (dir > 0) { go(i >= cards.length - 1 || track.scrollLeft >= maxScroll() - 2 ? 0 : i + 1); }
      else { go(i <= 0 ? cards.length - 1 : i - 1); }
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });
    mark(0);
  }

  /* ---------- przyklejony pasek CTA (opcjonalny przełącznik w sekcji) ---------- */
  function initSticky(wrap) {
    if (wrap.__lklp) return;
    wrap.__lklp = true;
    var inner = wrap.querySelector('.lklp-cta__in');
    if (!inner) return;
    wrap.classList.add('lklp-cta--sticky-on');
    var queued = false;
    function measure() {
      if (!inner.classList.contains('is-stuck')) { wrap.style.setProperty('--lklp-cta-h', inner.offsetHeight + 'px'); }
    }
    function update() {
      queued = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var r = wrap.getBoundingClientRect();
      var past = (window.pageYOffset || document.documentElement.scrollTop) > vh * 0.6;
      var visible = r.top < vh - 12 && r.bottom > 0;
      var stuck = past && !visible && r.top >= 0;
      if (stuck !== inner.classList.contains('is-stuck')) {
        if (stuck) measure();
        inner.classList.toggle('is-stuck', stuck);
      }
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    measure();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', function () { measure(); queue(); }, { passive: true });
    queue();
  }

  function init(root) {
    initVideos(root);
    qsa('[data-lklp-slider]', root).forEach(initSlider);
    qsa('[data-lklp-sticky]', root).forEach(initSticky);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); }
  else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
